import React from 'react';
import { ActivityIndicator, StyleSheet, Image, View } from 'react-native';
import { s, v } from '../../../utils/libs';

const Navloader = () => {
  return (
    <View
      style={{
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#1560bd',
      }}>
      <Image
        source={require('../../../assets/splash/BizplusLogoSplash.webp')}
        style={{
          width: s(200),
          height: s(200),
          resizeMode: 'contain',
        }}
      />
      <View style={styles.bottom}>
        <ActivityIndicator
          style={{ width: s(20) }}
          size={'large'}
          color={'#ffffff'}
        />
      </View>
    </View>
  );
};

export default Navloader;

const styles = StyleSheet.create({
  bottom: {
    position: 'absolute',
    bottom: v(80),
  },
});
